// import { useEffect, useMemo, useState } from "react";
// import { BiCheck } from "react-icons/bi";
// import { BsFunnel } from "react-icons/bs";
// import { IoClose } from "react-icons/io5";
import { cn } from "../../utils/lib";
// import { Button, IconButton, Paragraph, Tooltip } from "../common";
// import { Modal } from "./Modal";

// interface ColumnProps {
//     label: string | React.ReactNode | undefined;
//     accessor: string;
// }

interface TableProps {
    columns: any;
    data: any;
    headerClassName?: string;
    bodyClassName?: string;
    onRowClick?: (id?: string, value?: any, data?: any) => void;
    containerHeight?: string;
    isStickyHeader?: boolean;
    isStacicRow?: boolean;
    isLoading?: boolean;
    isDynamicColumn?: boolean;
    tableKey?: string;
    onApply?: (columns: string[]) => void;
    isSelectable?: boolean;
    onSaveSelected?: (selectedRows: any[]) => void;
}

const Table = ({
    columns,
    data,
    headerClassName,
    bodyClassName,
    onRowClick,
    containerHeight,
    isStickyHeader = false,
    isStacicRow = false,
    isLoading = false,
    // isDynamicColumn = false,
    // tableKey,
    // onApply,
    // isSelectable = false,
    // onSaveSelected,
}: TableProps) => {
    // const [visibleColumns, setVisibleColumns] = useState<string[]>(() => {
    //     const savedColumns = localStorage.getItem(tableKey || "");
    //     return savedColumns
    //         ? JSON.parse(savedColumns)
    //         : columns.map((col: any) => col.accessor);
    // });
    // const [isColumnModalOpen, setIsColumnModalOpen] = useState(false);
    // const [selectedRows, setSelectedRows] = useState<any[]>([]);

    // useEffect(() => {
    //     if (isDynamicColumn && tableKey) {
    //         localStorage.setItem(tableKey, JSON.stringify(visibleColumns));
    //         onApply?.(visibleColumns);
    //     }
    // }, [visibleColumns, isDynamicColumn, tableKey]);

    // const filteredColumns = useMemo(
    //     () => columns.filter((column: any) => visibleColumns.includes(column.accessor)),
    //     [columns, visibleColumns],
    // );

    // const toggleColumn = (accessor: string) => {
    //     setVisibleColumns((prev) => {
    //         if (prev.includes(accessor)) {
    //             if (prev.length === 1) return prev;
    //             return prev.filter((col) => col !== accessor);
    //         } else {
    //             return [...prev, accessor];
    //         }
    //     });
    // };

    // const toggleAllColumns = () => {
    //     if (visibleColumns.length === columns.length) {
    //         const firstColumn = columns[0].accessor;
    //         setVisibleColumns([firstColumn]);
    //         onApply?.([firstColumn]);
    //     } else {
    //         const allColumns = columns.map((col: any) => col.accessor);
    //         setVisibleColumns(allColumns);
    //         onApply?.(allColumns);
    //     }
    // };

    // const toggleRowSelection = (row: any) => {
    //     setSelectedRows((prev) => {
    //         const isSelected = prev.some((r) => r.id === row.id);
    //         return isSelected ? prev.filter((r) => r.id !== row.id) : [...prev, row];
    //     });
    // };

    // const isRowSelected = (row: any) => selectedRows.some((r) => r.id === row.id);

    // const toggleSelectAll = () => {
    //     if (selectedRows.length === data.length) {
    //         setSelectedRows([]);
    //     } else {
    //         setSelectedRows([...data]);
    //     }
    // };

    // const isSelectAll = () => selectedRows.length === data.length;

    return (
        <div className="relative w-full ">
            <div
                className={cn(
                    "relative overflow-auto no-scrollbar rounded-lg border bg-white transition-all duration-200 ease-linear",
                    isStickyHeader && containerHeight ? containerHeight : "max-h-60",
                )}
            >
                <table className="w-full ">
                    <thead
                        className={cn(
                            "border-b bg-primary ",
                            isStickyHeader ? "sticky top-0 z-[1]" : "",
                        )}
                    >
                        <tr>
                            {columns?.map((column: any, index: any) => (
                                <th
                                    key={column.accessor}
                                    align="left"
                                    className={cn(
                                        "text-xl font-bold py-1.5 px-2 truncate overflow-auto",
                                        headerClassName,
                                        isStacicRow && index === 0
                                            ? "sticky left-0 z-[12] bg-primary"
                                            : "",
                                    )}
                                >
                                    <div className="flex items-center  justify-between">
                                        {
                                            <div className="text-white text-[12px]  font-semibold ">{column.label}</div>
                                        }
                                        {/* {(isDynamicColumn || isSelectable) && index === 0 && (
                                            <div className="relative ml-4 pl-4">
                                                <div className="absolute -right-2 top-1/2 flex -translate-y-1/2 items-center gap-0.5">
                                                    {isSelectable && (
                                                        <Tooltip
                                                            tooltipText={
                                                                isSelectAll() ? "Unselect All" : "Select All"
                                                            }
                                                            position="top"
                                                        >
                                                            <IconButton
                                                                icon={
                                                                    isSelectAll() ? (
                                                                        <IoClose size={20} />
                                                                    ) : (
                                                                        <BiCheck size={20} />
                                                                    )
                                                                }
                                                                onClick={() => toggleSelectAll()}
                                                                ariaLabel="Select All"
                                                                color={isSelectAll() ? "red" : "blue"}
                                                                className="p-1"
                                                            />
                                                        </Tooltip>
                                                    )}
                                                    {isDynamicColumn && (
                                                        <Tooltip
                                                            tooltipText="Manage columns"
                                                            position="top"
                                                        >
                                                            <div className="relative">
                                                                <IconButton
                                                                    icon={<BsFunnel className="h-3 w-3" />}
                                                                    onClick={() => setIsColumnModalOpen(true)}
                                                                    ariaLabel="Manage columns"
                                                                    color="blue"
                                                                />
                                                                {columns?.length !== visibleColumns?.length && (
                                                                    <div className="absolute right-0.5 top-1 h-1.5 w-1.5 rounded-full bg-green-500" />
                                                                )}
                                                            </div>
                                                        </Tooltip>
                                                    )}
                                                </div>
                                            </div>
                                        )} */}
                                    </div>
                                </th>
                            ))}
                        </tr>
                    </thead>

                    {isLoading ? (
                        <tbody>
                            {Array.from({ length: 5 }).map((_, i) => (
                                <SkeletonRow key={i} columns={columns.length} />
                            ))}
                        </tbody>
                    ) : (
                        <tbody>
                            {data?.length > 0 ? (
                                data?.map((row: any, rowIndex: any) => (
                                    <tr
                                        key={rowIndex}
                                        className={cn(
                                            "border-b py-2 text-gray-600 text-[12px]",
                                            rowIndex % 2 === 0 ? "bg-white" : "bg-gray-50",
                                            onRowClick ? "cursor-pointer hover:bg-indigo-50" : "",
                                        )}
                                        onClick={() =>
                                            onRowClick && onRowClick(row.id, row.value, row)
                                        }
                                    >
                                        {columns.map((column: any, colIndex: any) => (
                                            <td
                                                key={column.accessor}
                                                align="left"
                                                className={cn(
                                                    "px-3 py-2 text-[12px] 2xl:px-4 2xl:py-2 2xl:text-sm",
                                                    bodyClassName,
                                                    isStacicRow &&
                                                    colIndex === 0 &&
                                                    "sticky left-0 z-[1] shadow-md",
                                                    colIndex === 0
                                                        ? rowIndex % 2 === 0
                                                            ? "bg-white"
                                                            : "bg-gray-50"
                                                        : "bg-transparent",
                                                )}
                                            >
                                                {/* {colIndex === 0 && isSelectable ? (
                                                    <label
                                                        className="flex cursor-pointer items-center gap-2 rounded-l-sm rounded-r-lg hover:bg-gray-100"
                                                        htmlFor={`checkbox-${rowIndex}`}
                                                        onClick={(e) => e.stopPropagation()}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            id={`checkbox-${rowIndex}`}
                                                            checked={isRowSelected(row)}
                                                            onChange={() => toggleRowSelection(row)}
                                                            className="h-3.5 w-3.5 cursor-pointer rounded-sm border focus:outline-primary 2xl:h-4 2xl:w-4"
                                                            style={{
                                                                accentColor: "#5051f9",
                                                            }}
                                                        />
                                                        {row[column.accessor]}
                                                    </label>
                                                ) : ( */}
                                                   { row[column.accessor]}
                                                {/* )} */}
                                            </td>
                                        ))}
                                    </tr>
                                ))
                            ) : (
                                <tr className="text-center">
                                    <td colSpan={columns.length} className="p-2 2xl:p-3 text-[12px]">
                                        <span className="text-[12px] text-gray-300 2xl:text-sm">
                                            No data
                                        </span>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    )}
                </table>
            </div>
            {/* {isSelectable && (
                <div className="mt-2 flex justify-end">
                    <Button
                        text="Save"
                        onClick={() => {
                            if (typeof onSaveSelected === "function") {
                                onSaveSelected(selectedRows);
                            }
                        }}
                        color="primary"
                        disabled={selectedRows.length === 0}
                    />
                </div>
            )}

            <Modal
                isOpen={isColumnModalOpen}
                onClose={() => setIsColumnModalOpen(false)}
                title="Column Visibility"
                size="sm"
            >
                <div className="max-h-80 overflow-y-auto 2xl:max-h-96">
                    <div className="space-y-1.5 2xl:space-y-2.5">
                        {columns.map((column: any) => (
                            <label
                                key={column.accessor}
                                className="flex cursor-pointer items-center rounded-lg p-2 hover:bg-gray-100 2xl:p-2.5"
                            >
                                <input
                                    type="checkbox"
                                    checked={visibleColumns.includes(column.accessor)}
                                    onChange={() => toggleColumn(column.accessor)}
                                    className="h-3.5 w-3.5 cursor-pointer 2xl:h-4 2xl:w-4"
                                    style={{
                                        accentColor: "#5051f9",
                                    }}
                                />
                                <span className="ml-3 text-xs font-medium text-gray-600 2xl:text-sm">
                                    {column.label}
                                </span>
                            </label>
                        ))}
                    </div>
                </div>

                <div className="pt-2">
                    <div className="flex items-center justify-between">
                        <Paragraph
                            text={`${visibleColumns.length} of ${columns.length} columns visible`}
                            className="text-sm text-gray-500"
                        />

                        <div className="flex items-center gap-3 2xl:gap-4">
                            <Button
                                onClick={toggleAllColumns}
                                text={
                                    visibleColumns.length === columns.length
                                        ? "Deselect All"
                                        : "Select All"
                                }
                                variant="outlined"
                                color={
                                    visibleColumns.length === columns.length ? "gray" : "blue"
                                }
                            />
                            <Button
                                onClick={() => setIsColumnModalOpen(false)}
                                text="Apply"
                                size="md"
                                color="primary"
                            />
                        </div>
                    </div>
                </div>
            </Modal> */}
        </div>
    );
};

export { Table };

const SkeletonRow = ({ columns }: { columns: number }) => (
    <tr className="animate-pulse border-b bg-white">
        {Array.from({ length: columns }).map((_, index) => (
            <td key={index} className="px-3 py-2">
                <div className="h-4 w-full rounded bg-gray-200" />
            </td>
        ))}
    </tr>
);
